import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function post(path, body) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Löschen fehlgeschlagen (${res.status}).`);
  }
  return data;
}

/**
 * Delete a mail or flyer and every linked agenda item.
 * @param {{ kind: 'mail'|'capture', id: string }} params
 */
export function forgetExtraction({ kind, id }) {
  return post("/api/extractions/forget", { kind, id });
}

/** @param {string} snapshotId */
export function restoreExtraction(snapshotId) {
  return post("/api/extractions/restore", { snapshotId });
}

/** @param {string} snapshotId */
export function purgeExtractionSnapshot(snapshotId) {
  return post("/api/extractions/purge", { snapshotId });
}
